export const scrollRight = () => {
  const element = document.getElementsByClassName('vue3-easy-data-table__main')[0]
  if (!element) return
  element.scrollLeft += 100
}
export const scrollLeft = () => {
  const element = document.getElementsByClassName('vue3-easy-data-table__main')[0]
  if (!element) return
  element.scrollLeft -= 100
}
